import React, { useEffect, useState } from 'react';

import { GenericLexicon } from '@rabbit/mixmaster/core';
import { BootI18N, BootLexicon } from './language';

export const MixMasterWrapper = (props: {
  children: React.ReactNode;
  bootstrap: GenericLexicon;
}) => {
  const [isBooting, setIsBooting] = useState(true);

  useEffect(() => {
    const asyncBoot = async () => {
      const configData = await BootLexicon(props.bootstrap);
      await BootI18N(props.bootstrap, configData);
      setIsBooting(false);
    };
    void asyncBoot();
  }, []);

  if (isBooting) return null;
  return <>{props.children}</>;
};
